import { connect } from 'react-redux'
import AlertModalView from 'support/popup_dialogs/views/components/alert_modal_view/AlertModalView'
import { hideDialog } from 'support/popup_dialogs/modal_alert_controller/ModalActions'
import Navigation from 'support/navigation'
import i18n from 'support/i18n'

const mapStateToProps = (props,Ownprops) => {
  // console.log(":props===",props,Ownprops)
  return{
    title: i18n.t('CONFIRMATION_MESSAGE'),
    description: Ownprops.description,
    mainButtonText: 'Okay',
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  console.log("🚀 ~ mapDispatchToProps ~ ownProps after success:", ownProps)
  return {
    mainButtonAction: () => {
      dispatch(hideDialog())
      // dispatch(Navigation.navigateToAllIdeas)
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AlertModalView)
